import noUiSlider from 'nouislider'
import Collapse from "bootstrap.native/dist/components/collapse-native.esm.js";

export default class ProductCategoriesExtension {
	constructor(naja, accordionTriggersSelector = null) {
		this.accordionTriggersSelector = accordionTriggersSelector;

		naja.addEventListener('init', () => {
			this.initRangeInputs();
			this.initNextProducts();
		});

		naja.addEventListener('complete', () => {
			this.initAccordions();
			this.initRangeInputs();
		});

		naja.snippetHandler.addEventListener('beforeUpdate', (event) => {
			if (event.snippet.id === 'snippet--products') {
				if (event.snippet.getAttribute('data-next-products-append') !== null) {
					event.snippet.innerHTML = event.snippet.innerHTML + event.content;
					event.snippet.removeAttribute('data-next-products-append');
					event.preventDefault();

					try {
						naja.uiHandler.bindUI(event.snippet);
					} catch (e) {
						console.log(e);
					}

					return false;
				}
			}
		});
	}

	initNextProducts() {
		document.addEventListener('click', function (e) {
			if (e.target !== undefined && e.target.getAttribute('data-next-products')) {
				e.preventDefault();
				let link = e.target.getAttribute('data-next-products');

				let products = document.getElementById('snippet--products');
				products.setAttribute('data-next-products-append', '1');

				naja.makeRequest('GET', link);
			}
		});
	}

	initAccordions() {
		if (this.accordionTriggersSelector === null) {
			return;
		}

		const accordionTriggers = document.querySelectorAll(this.accordionTriggersSelector);

		for (let i = 0; i < accordionTriggers.length; i++) {
			new Collapse(accordionTriggers[i]);
		}
	}

	initRangeInputs() {
		const rangeInputs = document.querySelectorAll('form.range input');
		rangeInputs.forEach((rangeInput) => {
			if (!rangeInput.hasAttribute('slider-initialized')) {
				rangeInput.addEventListener('keyup', function (e) {
					clearTimeout(this.getAttribute('keyup-timeout'));

					let wait = setTimeout(function () {
						this.form.dispatchEvent(new Event('submit'));
					}.bind(this), 800);

					this.setAttribute('keyup-timeout', wait);
				});

				rangeInput.setAttribute('slider-initialized', '')
			}
		});

		const rangeForms = document.querySelectorAll('form.range');
		rangeForms.forEach((rangeForm) => {
			if (!rangeForm.hasAttribute('slider-initialized')) {
				this.initSlider(rangeForm);
				rangeForm.setAttribute('slider-initialized', '')
			}
		});
	}

	initSlider(elem) {
		const priceSlider = elem.querySelector('.priceSlider');

		// noUiSlider
		if (noUiSlider !== undefined && priceSlider) {
			const inputMin  = elem.parentElement.querySelector('input[name=min]'),
				inputMax = elem.parentElement.querySelector('input[name=max]');

			const min = parseInt(inputMin.getAttribute('min')),
				max = parseInt(inputMin.getAttribute('max')),
				minSel = inputMin.value,
				maxSel = inputMax.value;

			noUiSlider.create(priceSlider, {
				start: [minSel, maxSel !== minSel ? maxSel : (maxSel + 1)], // aby byl posuvník rozevřený...
				connect: true,
				range: {
					'min': min,
					'max': min !== max ? max : (max + 1) // aby to neřvalo, že jsou stejný...
				}
			});

			if(min === max) {
				priceSlider.setAttribute('disabled', true);
			}

			priceSlider.noUiSlider.on('update', function (values, handle) {
				const value = values[handle];

				if (handle) {
					inputMax.value = Math.round(value);
				} else {
					inputMin.value = Math.round(value);
				}
			});

			priceSlider.noUiSlider.on('end', function () {
				inputMax.form.dispatchEvent(new Event('submit'));
			});

			inputMin.addEventListener('change', function () {
				priceSlider.noUiSlider.set([this.value, null]);
			});

			inputMax.addEventListener('change', function () {
				priceSlider.noUiSlider.set([null, this.value]);
			});
		}
	}
}